import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { WrenchIcon, CheckIcon, PhoneIcon, SendIcon, ClockIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function InstallationPage() {
  const services = [{
    title: 'Монтаж каркасного басейну',
    description: 'Професійне встановлення каркасних басейнів будь-якого розміру',
    price: 'від 2 500 ₴',
    includes: ['Підготовка майданчика', 'Збірка конструкції', 'Підключення фільтрації', 'Перевірка герметичності', 'Інструктаж з експлуатації']
  }, {
    title: 'Монтаж обладнання',
    description: 'Встановлення насосів, фільтрів, нагрівачів та іншого обладнання',
    price: 'від 1 500 ₴',
    includes: ['Підключення до системи', 'Налаштування параметрів', 'Тестування роботи', 'Гарантія на роботи']
  }, {
    title: 'Монтаж сауни',
    description: 'Встановлення електричних печей та обладнання для саун',
    price: 'від 3 000 ₴',
    includes: ['Встановлення печі', 'Підключення електрики', 'Укладання каміння', 'Перевірка безпеки']
  }, {
    title: 'Сервісне обслуговування',
    description: 'Регулярне технічне обслуговування та ремонт обладнання',
    price: 'від 800 ₴',
    includes: ['Діагностика обладнання', 'Чистка фільтрів', 'Заміна витратників', 'Консультація з догляду']
  }];
  const benefits = [{
    icon: UsersIcon,
    title: 'Досвідчені майстри',
    description: 'Наші спеціалісти мають багаторічний досвід роботи з басейнами та саунами'
  }, {
    icon: ShieldCheckIcon,
    title: 'Гарантія на роботи',
    description: 'Надаємо гарантію 12 місяців на всі виконані монтажні роботи'
  }, {
    icon: ClockIcon,
    title: 'Швидке виконання',
    description: 'Виїзд майстра протягом 1-3 днів після узгодження'
  }];
  return <main className="min-h-screen bg-slate-50" data-id="element-981">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-982">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-983">
          <nav className="flex items-center gap-2 text-sm" data-id="element-984">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-985">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-986">/</span>
            <span className="text-slate-900 font-medium" data-id="element-987">Монтаж та сервіс</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-988">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-989">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-990">
            Монтаж та сервіс
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-991">
            Професійний монтаж басейнів, обладнання та саун в Івано-Франківську
            та області
          </p>
        </div>

        {/* Benefits */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-992">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-md p-6 text-center" data-id="element-993">
              <div className="w-14 h-14 bg-sky-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-994">
                <benefit.icon className="w-7 h-7 text-sky-600" data-id="element-995" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-996">
                {benefit.title}
              </h3>
              <p className="text-slate-600" data-id="element-997">{benefit.description}</p>
            </motion.div>)}
        </div>

        {/* Services */}
        <section className="mb-16" data-id="element-998">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-999">
            Наші послуги
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1000">
            {services.map((service, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-md p-6" data-id="element-1001">
                <div className="flex items-start justify-between mb-4" data-id="element-1002">
                  <div data-id="element-1003">
                    <h3 className="text-xl font-semibold text-slate-900 mb-2" data-id="element-1004">
                      {service.title}
                    </h3>
                    <p className="text-slate-600" data-id="element-1005">{service.description}</p>
                  </div>
                  <span className="px-4 py-2 bg-sky-100 text-sky-700 rounded-xl text-lg font-bold whitespace-nowrap" data-id="element-1006">
                    {service.price}
                  </span>
                </div>
                <div className="border-t border-slate-100 pt-4" data-id="element-1007">
                  <p className="text-sm font-medium text-slate-700 mb-3" data-id="element-1008">
                    Що входить:
                  </p>
                  <ul className="space-y-2" data-id="element-1009">
                    {service.includes.map((item, i) => <li key={i} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-1010">
                        <CheckIcon className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-1011" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Service Area */}
        <section className="mb-16" data-id="element-1012">
          <div className="bg-white rounded-2xl shadow-md p-8" data-id="element-1013">
            <div className="flex items-center gap-3 mb-6" data-id="element-1014">
              <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1015">
                <WrenchIcon className="w-6 h-6 text-sky-600" data-id="element-1016" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900" data-id="element-1017">
                Зона обслуговування
              </h2>
            </div>
            <p className="text-slate-600 mb-4" data-id="element-1018">
              Виконуємо монтажні роботи в Івано-Франківську та в радіусі 50 км
              від міста. Для віддалених населених пунктів вартість виїзду
              розраховується індивідуально.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-1019">
              {['Івано-Франківськ', 'Калуш', 'Коломия', 'Надвірна', 'Долина', 'Тисмениця', 'Богородчани', 'Галич'].map((city, index) => <div key={index} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-1020">
                  <CheckIcon className="w-4 h-4 text-emerald-500" data-id="element-1021" />
                  {city}
                </div>)}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section data-id="element-1022">
          <div className="bg-gradient-to-br from-sky-500 to-cyan-600 rounded-2xl p-8 text-center text-white" data-id="element-1023">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1024">Замовити монтаж</h2>
            <p className="text-sky-100 mb-8 max-w-xl mx-auto" data-id="element-1025">
              Зв'яжіться з нами для консультації та розрахунку вартості робіт.
              Відповімо на всі питання та узгодимо зручний час виїзду майстра.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1026">
              <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" data-id="element-1027">
                <Button size="lg" variant="secondary" leftIcon={<SendIcon className="w-5 h-5" data-id="element-1029" />} className="bg-white text-sky-600 hover:bg-sky-50 w-full sm:w-auto" data-id="element-1028">
                  Написати в Telegram
                </Button>
              </a>
              <a href="tel:+380671234567" data-id="element-1030">
                <Button size="lg" variant="outline" leftIcon={<PhoneIcon className="w-5 h-5" data-id="element-1032" />} className="border-white/30 text-white hover:bg-white/10 w-full sm:w-auto" data-id="element-1031">
                  +38 (067) 123-45-67
                </Button>
              </a>
            </div>
          </div>
        </section>
      </div>
    </main>;
}